import type { CheckoutResult } from "@/lib/startTrialCheckout";

/** Shows checkout problems (or the new-tab link) instead of leaving a blank page. */
export function CheckoutNotice({ result, onRetry, retrying }: { result: CheckoutResult | null; onRetry: () => void; retrying?: boolean }) {
  if (!result) return null;
  if (result.status === "error") {
    return (
      <div role="alert" className="flex flex-col gap-3 rounded-xl border border-destructive/50 bg-destructive/10 p-4">
        <p className="font-body text-sm text-foreground">{result.message} You have not been charged.</p>
        <button type="button" onClick={onRetry} disabled={retrying}
          className="self-start rounded-lg bg-primary px-4 py-2 font-body text-sm font-semibold text-primary-foreground disabled:opacity-60">
          {retrying ? "Trying again…" : "Try again"}
        </button>
      </div>
    );
  }
  if (result.status === "opened_new_tab" || result.status === "popup_blocked") {
    return (
      <div className="flex flex-col gap-2 rounded-xl border border-primary/40 bg-card p-4">
        <p className="font-body text-sm text-foreground">
          {result.status === "opened_new_tab" ? "Secure checkout opened in a new tab." : "Your secure checkout is ready."}
        </p>
        <a href={result.url} target="_blank" rel="noopener noreferrer"
          className="self-start rounded-lg bg-primary px-4 py-2 font-body text-sm font-semibold text-primary-foreground">
          Open secure checkout
        </a>
      </div>
    );
  }
  return null;
}
